{{item.translation_key||item.label| translation|translationFromString | transformText :item?.text_transform}}
<div *ngFor="let integration of integrations">
    <nb-checkbox [(ngModel)]="integration.selected" (ngModelChange)=integrationsUpdated() [disabled]="checkDisable()"><label>{{integration.friendly_name || integration.name}}</label></nb-checkbox>
</div>
